import React, { useEffect, useState } from "react";
import "./DocsSend.scss";
import { ReactComponent as DocApproved } from "../../../assets/svg/docApproved.svg";
import { ReactComponent as DocReceived } from "../../../assets/svg/docReceived.svg";
import { useTranslation } from "react-i18next";

import { useAuthValidation } from "../../../hooks/useAuthValidation";
import api from "../../../services/api";
import DefaultLayout from "../../components/Layouts/DefaultLayout";

function DocsSend() {
  const [docs, setDocs] = useState([]);
  const { t } = useTranslation();
  const { user, loading } = useAuthValidation();

  useEffect(() => {
    if (!loading && user) {
      api
        .get("/documents")
        .then((response) => {
          setDocs(response.data);
        })
        .catch((error) => {
          console.error("Erro ao buscar dados do usuário:", error);
        });
    }
  }, [loading, user]);

  // Enquanto estiver carregando, mostra indicador de carregamento sem layout
  if (loading) {
    return <div className="loading">{t("loading")}</div>;
  }

  // Se não houver usuário, significa que já houve redirecionamento e não deve renderizar nada
  if (!user) {
    return null;
  }

  return (
    <DefaultLayout>
      <section className="docs-send">
        <div className="container">
          <h2>{t("docs-send-title")}</h2>
          <ul>
            {docs.length === 0 ? (
              <li>{t("docs-none")}</li>
            ) : (
              docs.map((doc, index) => (
                <li key={index} className="row">
                  {doc.status === "received" ? <DocReceived /> : <DocApproved />}
                  <div className="column">
                    <h3>{doc.number}</h3>
                    <div className="row">
                      <p>
                        {t("docs-send")} {doc.date}
                      </p>
                      {doc.status === "received" ? (
                        <span style={{ color: "#f48811" }}>{t("docs-send-wait")}</span>
                      ) : (
                        <span style={{ color: "#8acb23" }}>{t("docs-send-counts")}</span>
                      )}
                    </div>
                  </div>
                </li>
              ))
            )}
          </ul>
        </div>
      </section>
    </DefaultLayout>
  );
}

export default DocsSend;
